// Import the generated gRPC-Web client
import { CatalogItemReqClient } from '../generated/CatalogServiceClientPb';

// Base URL for your gRPC-Web proxy (Rust backend is running with tonic-web)
// This should match your GRPC_SERVER_ADDRESS from .env, accessible from the frontend.
// If running React on 3000 and Rust on 50051, it's usually `http://localhost:50051`
const GRPC_SERVER_URL = 'https://api.yutongoriginal.ru'; 
//const GRPC_SERVER_URL = process.env.REACT_APP_GRPC_SERVER_URL || 'https://api.intershina.pro';
// Create a new gRPC client instance
export const catalogClient = new CatalogItemReqClient(GRPC_SERVER_URL);